import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_get_inventory_transfer_lines_by_inventoryTransferLineIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryTransferLineIds: number[] }): 
  Promise<{ result: { Id?: number, InventoryTransfer?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferLineIds)) {
      missingRequiredInParams.push('\'inventoryTransferLineIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfer_lines_by_inventoryTransferLineIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryTransferLineIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, InventoryTransfer?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, Status?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferLineIds)) {
      missingRequiredInParams.push('\'inventoryTransferLineIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfer_lines_by_inventoryTransferLineIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryTransferLineIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, InventoryTransfer?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferLineIds)) {
      missingRequiredInParams.push('\'inventoryTransferLineIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfer_lines_by_inventoryTransferLineIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryTransferLineIds: number[]    }) {
        if(isNil(inParams.inventoryTransferLineIds)) {
          return true; 
        }
      return false;
    }
}
